import SignUpSettingModal from "./SignUpSettingModal";

export default SignUpSettingModal;
